<template>
	<div class="prebuild-stars">
		<star-rating
			:rating="reviews.average_rating"
			:rounded-corners="false"
			:read-only="true"
			:star-size="15"
			:show-rating="false"
			:increment="0.5"
			:border-width="2"
			active-color="#FBA40B"
			inactive-color="#FFFFFF"
			border-color="#FBA40B"
		/>
		<a
			class="prebuild-stars__review-count"
			v-scroll-to="{
				el: '#prebuild-reviews',
				offset: -50
			}"
		>
			{{ reviews.total_items }} Reviews
		</a>
	</div>
</template>

<script>
export default {
	name: "PrebuildStars",
	inject: ["currentPrebuild"],
	computed: {
		reviews() {
			return this.currentPrebuild.getReviews();
		}
	}
};
</script>

<style lang="scss">
.prebuild-stars {
	.vue-star-rating {
		.vue-star-rating-star {
			margin: 0;
		}
	}
}
</style>

<style lang="scss" scoped>
.prebuild-stars {
	display: flex;
	align-items: baseline;
	margin-bottom: 30px;

	&__review-count {
		color: #141226;
		font-size: 14px;
		letter-spacing: 0;
		text-decoration: underline;
		margin-left: 5px;
		cursor: pointer;
	}
}
</style>
